import React, { useState } from 'react';
import { Heart, Share2, Globe2, Zap, ChevronLeft, ChevronRight } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { useToast } from '../../hooks/use-toast';
import { imgUrl } from '../../lib/api';

const RoundBtn = ({ onClick, children, testId, className = '' }) => (
  <button onClick={onClick} data-testid={testId} className={`w-10 h-10 rounded-full bg-white/95 shadow flex items-center justify-center hover:bg-white ${className}`}>{children}</button>
);

export const Gallery = ({ listing }) => {
  const { t, toggleFav, isFav } = useApp();
  const { toast } = useToast();
  const [idx, setIdx] = useState(0);
  const images = (listing.images.length ? listing.images : ['https://images.unsplash.com/photo-1552710307-537199cd41c0?w=800']).map(imgUrl);
  const prev = () => setIdx((i) => (i - 1 + images.length) % images.length);
  const next = () => setIdx((i) => (i + 1) % images.length);
  const share = () => { navigator.clipboard?.writeText(window.location.href); toast({ title: t('detail.linkCopied') }); };

  return (
    <>
      <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-[#FAF7F2] mb-3" data-testid="listing-gallery">
        <img src={images[idx]} alt={listing.title} className="w-full h-full object-cover" />
        {images.length > 1 && (
          <>
            <RoundBtn onClick={prev} testId="gallery-prev" className="absolute left-3 top-1/2 -translate-y-1/2"><ChevronLeft className="w-5 h-5" /></RoundBtn>
            <RoundBtn onClick={next} testId="gallery-next" className="absolute right-3 top-1/2 -translate-y-1/2"><ChevronRight className="w-5 h-5" /></RoundBtn>
          </>
        )}
        <div className="absolute top-4 left-4 flex flex-col gap-2">
          {listing.boosted && <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-[#F2B441] text-[#1A1A1A] text-xs font-bold uppercase"><Zap className="w-3 h-3" /> {t('feat.boosted')}</span>}
          {listing.diasporaShipping && <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white text-[#0F8B5C] text-xs font-bold uppercase"><Globe2 className="w-3 h-3" /> Diaspora</span>}
        </div>
        <div className="absolute top-4 right-4 flex gap-2">
          <RoundBtn onClick={() => toggleFav(listing.id)} testId="detail-fav-button"><Heart className={`w-4 h-4 ${isFav(listing.id) ? 'fill-[#E8814A] text-[#E8814A]' : 'text-[#3F3A30]'}`} /></RoundBtn>
          <RoundBtn onClick={share} testId="detail-share-button"><Share2 className="w-4 h-4 text-[#3F3A30]" /></RoundBtn>
        </div>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-2">
        {images.length > 1 && images.map((src, i) => (
          <button key={`${src}-${i}`} onClick={() => setIdx(i)} data-testid={`gallery-thumb-${i}`} className={`shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 ${idx === i ? 'border-[#0F8B5C]' : 'border-transparent opacity-60 hover:opacity-100'}`}>
            <img src={src} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </>
  );
};
